module.exports = __webpack_public_path__ + "img/420vsETF.74bc9ed7.png";